import { Button, Card, Space, Input, Table, Message } from "@arco-design/web-react";
import OperationButton from "@/components/OperationButton";
import { Currency } from "@/components/Numeric";
import { EnumLabel, EnumSelect } from "@/components/Enum";
import { StatusDef, Status } from "@/enums/status";
import { useCallback, useEffect, useState } from "react";
import { VendorAPI } from "@/apis/purchasing";
import { useNavigate } from "react-router-dom";
import { IconPlus, IconEdit, IconCheck, IconClose } from "@arco-design/web-react/icon";
import { VendorAdd } from "./vendor-add";
import { VendorEdit } from "./vendor-edit";
import { VendorInfo } from "./vendor-info";

export const Vendor = () => {
    const navigate = useNavigate();
    const [vendorName, setVendorName] = useState("");
    const [status, setStatus] = useState(1);
    const [data, setData] = useState();
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    const getVendors = useCallback(async () => {
        let res = await VendorAPI.query({ page, status, vendorName });
        setTotal(res.total);
        setData(res.records);
    }, [page, status, vendorName]);

    useEffect(() => {
        getVendors();
    }, [getVendors]);

    return (
        <Card title="Vendor" extra={
            <Space>
                <Input allowClear placeholder="Vendor Name" value={vendorName} onChange={(val) => { setVendorName(val) }} />
                <EnumSelect enumObj={StatusDef} value={status} style={{ width: 100 }} allowAll placeholder="Status"
                    onChange={values => setStatus(values)}
                />
                <Button type="primary" icon={<IconPlus />} onClick={() => navigate("/workspace/purchasing/vendor/add")}>Add New Vendor</Button>
            </Space>
        }>
            <Table rowKey="id" columns={[
                {
                    title: "Vendor Name",
                    render: (col, record) => <Button type="text" onClick={() => navigate(`/workspace/purchasing/vendor/${record.id}`)}>{record.vendorName}</Button>
                },
                {
                    title: "Status",
                    render: (col, record) => <EnumLabel enumObj={StatusDef} value={record.status} />
                },
                {
                    title: "Balance",
                    render: (col, record) => <Currency value={record.balance} />
                },
                {
                    title: "Operations",
                    width: 120,
                    render: (col, record) => (
                        <Space size="mini">
                            <OperationButton icon={<IconEdit />} label="Edit"
                                onClick={() => navigate(`/workspace/purchasing/vendor/${record.id}/edit`)} />
                            {record.status === Status.Active &&
                                <OperationButton icon={<IconClose />} label="Disable" status="danger"
                                    onClick={async () => {
                                        try {
                                            await VendorAPI.disable(record.id);
                                            Message.success("Vendor disabled");
                                            getVendors();
                                        } catch (error) {
                                            Message.error(error.message);
                                        }
                                    }} />
                            }
                            {record.status === Status.Inactive &&
                                <OperationButton icon={<IconCheck />} label="Enable" status="success"
                                    onClick={async () => {
                                        try {
                                            await VendorAPI.enable(record.id);
                                            Message.success("Vendor enabled");
                                            getVendors();
                                        } catch (error) {
                                            Message.error(error.message);
                                        }
                                    }} />
                            }
                        </Space>
                    )
                },
            ]} data={data}
                pagination={{ total, current: page, pageSize: 20 }}
                onChange={(pagination) => {
                    setPage(pagination.current);
                }} />
        </Card>
    );
}

Vendor.Add = VendorAdd;
Vendor.Edit = VendorEdit;
Vendor.Info = VendorInfo;
